import React from 'react'
import Chip from '@mui/material/Chip'
import Avatar from '@mui/material/Avatar'

export interface PartnerChipProps {
  partner: {
    nome: string
    imagemUrl?: string | null
  }
  onRemove?: () => void
}

const PartnerChip: React.FC<PartnerChipProps> = ({ partner, onRemove }) => {
  return (
    <Chip
      label={partner.nome}
      onDelete={onRemove}
      avatar={<Avatar src={partner.imagemUrl || '/assets/images/user.png'} />}
      sx={{ ml: 1 }}
    />
  )
}

export default PartnerChip
